import React, { Suspense, useState, useEffect, useRef } from 'react';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { ProgressBar } from 'primereact/progressbar';

import MainLayout from './layout/MainLayout';
import SecondaryLayout from './layout/SecondaryLayout';
import VersionChecker from './components/VersionChecker';

import routes from './routes';
//import echo from './echo';

import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.scss';

import { useGasCheck, useJm, useUsers, useArtikal, useValuta, useParam, useStatus, useVno, useNamenaPotrosnje, useMrs, useNi, useRvp, useSi, useTipTrosila, useMarkaTrosila, useGroups, usePp } from './store';

const App = () => {
    const { setUser } = useGasCheck();
    const { fetchJms } = useJm();
    const { fetchUsers } = useUsers();
    const { fetchArtikli } = useArtikal();
    const { fetchValute } = useValuta();
    const { fetchParams } = useParam();
    const { fetchStatuss } = useStatus();
    const { fetchVnos } = useVno();
    const { fetchNamenaPotrosnjes } = useNamenaPotrosnje();
    const { fetchNis } = useNi();
    const { fetchRvps } = useRvp();
    const { fetchMrss } = useMrs();
    const { fetchSis } = useSi();
    const { fetchTipTrosilas } = useTipTrosila();
    const { fetchMarkaTrosilas } = useMarkaTrosila();
    const { fetchGroups } = useGroups();
    const { fetchDistributer, fetchKorisnikAplikacije } = usePp();

    // šifarnici koji se ucitavaju pri pokretanju aplikacije
    useEffect(() => {
        // console.log('init load data from server...');

        // setUser();
        // fetchJms();
        fetchUsers();
        // fetchArtikli();
        // fetchValute();
        // fetchParams();
        fetchStatuss();
        // fetchVnos();
        // fetchNamenaPotrosnjes();
        // fetchMrss();
        // fetchNis();
        // fetchRvps();
        // fetchSis();
        // fetchTipTrosilas();
        // fetchMarkaTrosilas();
        // fetchGroups();
        fetchDistributer();
        fetchKorisnikAplikacije();

        // setArtikal();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <VersionChecker />
            <Suspense fallback={<ProgressBar mode="indeterminate" style={{ height: '6px' }}></ProgressBar>}>
                <Routes>
                    <Route path="/" element={<MainLayout />}>
                        {/* load routest from route.js file */}
                        {routes.map((route, index) => (
                            <Route key={route.path} path={route.path} element={route.element} />
                        ))}
                    </Route>
                    {/* <Route path="/elektronskinalog" element={<SecondaryLayout />}>
                        <Route index element={<EkranProizvodnja />} />
                    </Route> */}
                </Routes>
            </Suspense>
        </>
    );
};

export default App;

